<template>
  <div class="page-wrap">
    <div class="wraper">
      <img class="t-img" :src="img" >
      <div class="content-wrap">
        <div class="school-note">
          面向应届生的职位，我们会在高校安排宣讲会。<br>宣讲会现场，给岗位有意者安排笔试。
        </div>
        <div class="seminar">
          <div class="seminar-list">
            <div class="seminar-item" v-for="(item, index) in info" :key="index">
              <div class="module-label">{{item.name}}</div>
              <div class="box-tag-item" v-for="(detailitem, detailindex) in item.list" :key="detailindex">
                <div class="box-tag-name" :class="{'boxtagnamebg': !detailitem.type}">
                  <div class="box-tag-wrap">{{detailitem.type ? "线上直播" : "线下宣讲"}}</div>
                </div>
                <div class="box-tag-content">
                  <div class="description" v-html="changeRN(detailitem.description)"></div>
                  <div class="place" v-if="!detailitem.type" v-html="changeRN(detailitem.place)"></div>
                </div>
                <div class="seminar-qrcode" v-if="detailitem.type && detailitem.picturepath">
                  <img :src="'https://erp2.wenhua.com.cn/'+ detailitem.picturepath" class="wechat-img">
                  <!-- <img :src="detailitem.picturepath" class="wechat-img"> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
import hr from '../../assets/js/index.js'
export default {
  data() {
    return {
      img: `${process.env.BASE_URL}ImgFiles/top-xiaoz_02.jpg`,
      info: []
    }
  },
  created() {
    this.$http.post("/api/dataapi/route?whid=wenhua").then((res) => {
      if (res.status != 200 || !res.data) return;
      this.info = res.data;
    });
  },
  methods: {
    changeRN: hr.changeRN
  }
}
</script>

<style scoped>
.page-wrap {
  
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
}
.content-wrap {
  padding: 1.1rem 0.3386rem;
  min-height: 15.25em;
}
.school-note {
  font-size: 0.508rem;
  line-height: 1rem;
  color: #676767;
}
.seminar {
  margin-top: 1.1rem;
}
.seminar-item {
  margin-bottom: 0.8rem;
}
.seminar-qrcode {
  display: table-cell;
  width: 2.9rem;
  vertical-align: middle;
}
.wechat-img {
  width: 2.8rem;
  vertical-align: middle;
  padding-right: 0.4rem;
}
</style>